"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.links = void 0;
exports.links = [
    {
        title: 'PROFILE.MY_ANNOUNCEMENTS',
        url: "announcements",
        icon: 'icon-my-annoucements',
    },
    {
        title: 'PROFILE.WISHLIST',
        url: 'wishlist',
        icon: 'icon-favorites',
    },
    {
        title: 'PROFILE.SAVED_SEARCHES',
        url: 'saved-searches',
        icon: 'icon-ic-saved-search',
    },
    {
        title: 'PROFILE.SETTINGS',
        url: 'settings',
        icon: 'icon-settings',
    },
];
